import React, { Component } from 'react';

import AppBar from 'material-ui/AppBar';
import { Step, Stepper, StepLabel } from 'material-ui/Stepper';

import EnterPhone from './EnterPhone';
import Payment from './Payment';
import PayPal from './PayPal';
import Config from '../conf';

import 'whatwg-fetch';

class PaymentContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      phone: '',
      email: '',
      numberPlate: '',
      carType: null,
      washType: null,
      washPrice: 0,
      isSmallScreen: false,
      step: 0
    };

    this.next = this.next.bind(this);
    this.back = this.back.bind(this);
    this.updateField = this.updateField.bind(this);
    this.setHasError = this.setHasError.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateField(fieldName, fieldValue, callBack) {
    const detailsObj = {};
    detailsObj[fieldName] = fieldValue;
    this.setState(detailsObj, callBack);
  }

  setHasError(fieldName, hasError) {
    const detailsObj = {};
    detailsObj[fieldName + 'Error'] = hasError;
    this.setState(detailsObj);
  }

  next(step) {
    this.setState((prevState, props) => {
      return {
        step: step ? step : prevState.step + 1
      };
    });
  }

  back() {
    this.setState((prevState, props) => {
      return {
        step: prevState.step - 1,
      };
    });
    this.updateField('goBackClicked', true);
  }

  updateDimensions() {
    const width = window.innerWidth;
    const small = width < 768;
    this.setState({
      isSmallScreen: small
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const style = {
      container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: this.state.isSmallScreen ? '5%' : '10%',
        marginRight: this.state.isSmallScreen ? '5%' : '10%'
      },
      gap: {
        marginTop: '3vh'
      },
      navbar: {
        height: 120,
        backgroundColor: '#fff'
      },
      navbarInner: {
        height: 120,
        marginTop: 0,
        textAlign: 'center'
      },
      imageLogo: {
        marginTop: 8,
        height: 100,
        width: 'auto',
        maxWidth: 800
      },
      imageLocalLogo: {
        marginTop: 8,
        height: 100,
        width: 'auto',
        maxWidth: 200
      },
      mainlogo: {
        backgroundImage: 'url("' + Config.LOGO_PATH + '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        width: '100%',
        maxWidth: '50%',
        backgroundSize: 'contain',
        display: 'inline-block'
      },
      mainlogocenter: {
        backgroundImage: 'url("' + Config.LOGO_PATH + '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        maxWidth: '50%',
        backgroundSize: 'contain',
        display: 'inline-block'
      },      
      locallogo: {
        backgroundImage: 'url("' + Config.LOCAL_LOGO_PATH + '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
        width: '100%',
        maxWidth: '50%',
        backgroundSize: 'contain',
        display: 'inline-block'
      }
    };

    return (
      <div>
        <AppBar
          title={
            <div>
              <div alt="logo" style={{ ...style.imageLogo, ...Config.LOCAL_LOGO_PATH ? style.mainlogo : style.mainlogocenter}} ></div>
              {Config.LOCAL_LOGO_PATH &&
                <div src={Config.LOCAL_LOGO_PATH} alt="local logo" style={{ ...style.imageLocalLogo, ...style.locallogo }} ></div>
              }
            </div>
          }
          style={style.navbar}
          titleStyle={style.navbarInner}
          showMenuIconButton={false}
        />

        <div style={style.gap} />

        <div style={style.container}>
          {!this.state.isSmallScreen && 
            <Stepper activeStep={this.state.step}>
              <Step style={style.step}>
                <StepLabel>Enter Phone</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Payment</StepLabel>
              </Step>
            </Stepper>
          }

          {this.state.step === 0 &&
            <EnterPhone
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
              next={this.next}
              {...this.props}
            />
          }
          {this.state.step === 1 &&
            <Payment
              details={this.state}
              updateField={this.updateField}
              back={this.back}
            />
          }
          {this.state.step === 2 &&
            <PayPal
              details={this.state}
              updateField={this.updateField}
              back={this.back}
            />
          }          
        </div>

        <div id="footer">
          <div id="footerText">
            Powered by <a target="_blank" href="https://www.wipehero.com.au/">WipeHero</a> &copy; 2017
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentContainer;



// WEBPACK FOOTER //
// ./src/app/payment/index.js